export default "__VITE_ASSET__BCKxhhl7__"